import React, { useState } from "react"
import * as styles from "./CircleMenu.module.css"
import classNames from "classnames"
import ArrowSpin from "../../../../images/arrow-spin.inline.svg"
import { Link } from "gatsby"
import useDeviceType from "../../../../hooks/useDeviceType"
import SpeechBabble from "../../../new-components/SpeechBabble/SpeechBabble"
import handleTypeCircleMenu, { SolutionPages } from "./handleTypeCircleMenu"
import { useLocation } from "@reach/router"

const CircleMenu = () => {
  const { pathname } = useLocation()

  const pagetype = pathname.split("/")[2] as SolutionPages

  const [rotateMenu, setRotateMenu] = useState(false)

  const handleRotateMenu = () => {
    setRotateMenu(preRotateMenu => !preRotateMenu)
  }

  const DeviceType = useDeviceType()

  return (
    <div className={styles.container}>
      {DeviceType === "mobile" || DeviceType === "tablet" ? (
        <div
          className={classNames(styles.centerCircle, styles.toggle, {
            [styles.active]: rotateMenu,
          })}
          onClick={handleRotateMenu}
        >
          <ArrowSpin />
        </div>
      ) : (
        <div className={styles.centerCircle} />
      )}
      <div className={styles.polygonBox}>
        <ul
          className={classNames(styles.menu, { [styles.active]: rotateMenu })}
        >
          {handleTypeCircleMenu(pagetype).map(
            ({ title, link, svg: SVG, details: { text, x, y, type } }, i) => (
              <li
                key={i}
                style={{
                  transform: `translateY(-50%) rotate(calc(360deg / 8 * ${i}))`,
                }}
              >
                <Link
                  to={link}
                  style={
                    !rotateMenu
                      ? {
                          transform: `translateY(-50%) rotate(calc(360deg / -8 * ${i} + 22.5deg))`,
                        }
                      : {
                          transform: `translateY(-50%) rotate(calc(360deg / -8 * ${i} + 22.5deg + 180deg))`,
                        }
                  }
                >
                  <div className={styles.speechBabbleContent}>
                    <SpeechBabble text={text} x={x} y={y} type={type} />
                  </div>

                  <SVG />
                  <span>{title}</span>
                </Link>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  )
}

export default CircleMenu
